import "./page_scale.css"
import {left_side_bar_size} from "./left_sidebar.js";
import {right_side_bar_size} from "./right_sidebar.js";
import {logError} from "../function.js";

$(document).ready(function () {
    function wide() {
        try {
            $("#page").removeClass("container-normal")
            $("#page").removeClass("container-max")
            $("#page").addClass("container-wides")
            $(".page_scale").addClass("ds-none")
            $(".menu_sub_max").removeClass("ds-none")
            jqueryts.storage.local.put("page_scale", "wide");
            document.cookie = "page_scale=wide; path=/";
            right_side_bar_size()
            left_side_bar_size()
            search_content_size()
        } catch (e) {
            logError(e)
        }
    }

    function max() {
        try {
            $("#page").removeClass("container-normal")
            $("#page").removeClass("container-wides")
            $("#page").addClass("container-max")
            $(".page_scale").addClass("ds-none")
            $(".menu_sub_normal").removeClass("ds-none")
            jqueryts.storage.local.put("page_scale", "max");
            document.cookie = "page_scale=max; path=/";
            right_side_bar_size()
            left_side_bar_size()
            search_content_size()
        } catch (e) {
            logError(e)
        }
    }

    function normal() {
        try {
            $("#page").removeClass("container-max")
            $("#page").removeClass("container-wides")
            $("#page").addClass("container-normal")
            $(".page_scale").addClass("ds-none")
            $(".menu_sub_wide").removeClass("ds-none")
            jqueryts.storage.local.put("page_scale", "normal");
            document.cookie = "page_scale=normal; path=/";
            right_side_bar_size()
            left_side_bar_size()
            search_content_size()
        } catch (e) {
            logError(e)
        }
    }

    function search_content_size(){
        if ($$("app-search")!==undefined)
            $$("app-search").resize()
    }


    $(".menu_sub_wide").on("click", function () {
        wide()
    })
    $(".menu_sub_max").on("click", function () {
        max()
    })
    $(".menu_sub_normal").on("click", function () {
        normal()
    })
    if (jqueryts.storage.local.get("page_scale")) {
        try {
            if (jqueryts.storage.local.get("page_scale") === "normal") normal();
            if (jqueryts.storage.local.get("page_scale") === "wide") wide();
            if (jqueryts.storage.local.get("page_scale") === "max") max();
        } catch (e) {
            logError(e)
        }
    }
})
